import { type GridColDef, Text, EllipsisText } from '@shared/components';
import { dayjs } from '@shared/utils';
export interface Announcement {
  id: string;
  title: string;
  announceAt: Date | null;
}

export const columns: GridColDef<Announcement>[] = [
  {
    field: 'announceAt',
    headerName: 'วันที่ประกาศ',
    width: 120,
    sortable: false,
    renderCell: (params) => {
      return <Text>{dayjs(params.row.announceAt).format('DD/MM/YYYY')}</Text>;
    },
  },
  {
    field: 'title',
    headerName: 'หัวข้อประกาศ',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return (
        <EllipsisText maxLines={2} variant='body1Semibold'>
          {params.row.title}
        </EllipsisText>
      );
    },
  },
];
